import { io } from "socket.io-client";
import { ClockSync } from "@unfaithful/shared";
import { FF_NAMESPACE } from "@playpop/finalfew";
import { keepClockSynced } from "./connection.js";
import { defaultServerUrl } from "./storage.js";
import { savedPass } from "./pass.js";
export function connectFinalFew() {
    return io(new URL(FF_NAMESPACE, defaultServerUrl()).toString(), {
        transports: ["websocket", "polling"],
        tryAllTransports: true,
        auth: (cb) => cb({ pass: savedPass() ?? undefined }),
        reconnection: true,
        reconnectionDelay: 500,
        reconnectionDelayMax: 3000,
    });
}
/** An acknowledged request; rejects with the server's message. */
export function ffRequest(socket, event, payload) {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        socket.timeout(8000).emit(event, payload, (err, result) => {
            if (err)
                return reject(new Error("The game didn't answer. Check your connection."));
            if (result.ok)
                resolve(result.data);
            else
                reject(new Error(result.error ?? "Something went wrong."));
        });
    });
}
/** Keep this socket's clock in step with the server's (it answers the same pings). */
export function syncFinalFewClock(socket, clock = new ClockSync()) {
    return keepClockSynced(socket, clock);
}
/** Pounds, as the show writes them. */
export const pounds = (n) => `£${Math.round(n).toLocaleString("en-GB")}`;
//# sourceMappingURL=finalfew.js.map